import React from 'react';
import { makeStyles, useTheme } from 'pencil/styles';
import cx from 'classnames';

const useStyles = makeStyles(
  (theme) => ({
    root: {
      textAlign: 'center',
    },
    logo: {
      maxWidth: 140,
      [theme.breakpoints.down('sm')]: {
        maxWidth: 110,
      },
      margin: '0 auto',
      height: 65,
    },
  }),
  { name: 'MlcGoAppIcon' },
);

const AppIcon = ({ className, ...props }) => {
  const classes = useStyles();
  const theme = useTheme();
  return (
    <div className={cx(classes.root, className)} {...props}>
      <a href="/">
        <img
          className={cx(classes.logo, className)}
          title={theme.branding.company.name}
          src={theme.branding.logo.standard}
        />
      </a>
    </div>
  );
};

export default AppIcon;
